var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStatusLive = function SvgStatusLive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1875 16.2727V6.72727C15.1875 5.08949 13.7952 3.625 11.9062 3.625C10.0173 3.625 8.625 5.08949 8.625 6.72727V16.2727C8.625 17.9105 10.0173 19.375 11.9062 19.375C13.7952 19.375 15.1875 17.9105 15.1875 16.2727ZM11.9062 1C8.64432 1 6 3.56419 6 6.72727V16.2727C6 19.4358 8.64432 22 11.9062 22C15.1682 22 17.8125 19.4358 17.8125 16.2727V6.72727C17.8125 3.56419 15.1682 1 11.9062 1Z",
    fill: "#B2D145"
  })));
};
export default SvgStatusLive;